const config = {
	activeMode: "light", // This can be light or dark
	// Kept as a single frozen value: the palette is no longer a preference and
	// the eight [data-theme] blocks it used to select are gone. Charts still read
	// it as a recompute trigger alongside activeMode, so the field stays.
	activeTheme: "AZUL_THEME",
	activeLayout: "vertical", // This can be vertical or horizontal
	isLayout: "full", // This can be full or boxed
	isSidebarHover: false,
	isCollapse: "full-sidebar",
	isLanguage: "en",
	isCardShadow: true,
	isMobileSidebar: false,
	isHorizontal: false,
	sidebarWidth: 240,
	miniSidebarWidth: 80,
	topbarHeight: 70,
};

export default config;
